/**
 * Created by rlopez on 08/11/16.
 */

import $ from 'jquery';

import RestService from 'RestService.js';
import undoService from 'UndoService.js';
import eventBus from 'EventBus';
import NotificationService from 'NotificationService.js';
import textConstants        from 'TextConstants';
import constants    from 'Constants.js';
import listService      from 'ListService.js';
import util        from 'util/Util.js';

const ICON_EMPTY = constants.DB_ICON_EMPTY;

//==========================================================================================
// This singleton controller handles resizing a control by dragging its borders.
//==========================================================================================
class ServiceURLController{

    constructor() {

    }

    renderSourceURL(mainView,data,groupType,itemId,dataTarget){
        console.log("Sources",data);
        var nodes = [];
        if (data) {
            //Use this in case the info comes from DB in a future
        }
        else{
            nodes = [{
                nodeName: 'REST/SOAP',
                url: '#',
                icon: ICON_EMPTY,
                id: "1",
                groupType: groupType,
                nodeType: 'restSoapItem',
                hasChildren: false,
                toggleIcon: ''
            }]
        }

        var group = mainView.replaceGroupItemsInModel('settingsSections', 'Account Settings',itemId,nodes);


        mainView.addItemsToGroup(group, dataTarget);
    }

    
}

const serviceURLController = new ServiceURLController();
export default serviceURLController;
